import React, { Component } from 'react';
import Autocomplete from '../common/autocomplete';
import DateInput from '../common/date/';
import strings from '../locales/';
import Graph from './evolutionGraphTable';

const Table = props => (
  <div className="container-summary-table">
    <ul className="container-summary-table-ul">
      <li className="container-summary-table-li">
        <strong>{props.language.detail_waiting_times.fulfillment}:</strong>
        {props.language.detail_waiting_times.allIndicators}
        <ul>
          <li>Test</li>
          <li>Test</li>
        </ul>
      </li>
    </ul>
    <table>
      <thead>
        <tr>
          <th className="width200">{props.language.detail_waiting_times.categorie}</th>
          <th>{props.language.detail_waiting_times.fulfillment}</th>
          <th className="width200">{props.language.detail_waiting_times.drivers}</th>
        </tr>
      </thead>
      <tbody>
        <tr className="green">
          <td>Operación 1</td>
          <td>
            <div className="graph-line-container">
              <div className="graph-line">
                <Graph data={props.data} id="test1" />
              </div>
              <div className="graph-line-text">
                <h6 className="green">70%</h6>
                <span className="arrow green">
                  <i className="fas fa-arrow-up" />
                </span>
                <span className="number green">10%</span>
              </div>
            </div>
          </td>
          <td>20</td>
        </tr>
        <tr className="yellow">
          <td>Operación 2</td>
          <td>
            <div className="graph-line-container">
              <div className="graph-line">
                <Graph data={props.data} id="test2" />
              </div>
              <div className="graph-line-text">
                <h6 className="yellow">70%</h6>
                <span className="arrow green">
                  <i className="fas fa-arrow-up" />
                </span>
                <span className="number green">10%</span>
              </div>
            </div>
          </td>
          <td>30</td>
        </tr>
        <tr className="yellow">
          <td>Operación 3</td>
          <td>
            <div className="graph-line-container">
              <div className="graph-line">
                <Graph data={props.data} id="test3" />
              </div>
              <div className="graph-line-text">
                <h6 className="green">70%</h6>
                <span className="arrow green">
                  <i className="fas fa-arrow-up" />
                </span>
                <span className="number green">10%</span>
              </div>
            </div>
          </td>
          <td>40</td>
        </tr>
      </tbody>
    </table>
  </div>
);

export default Table;



// WEBPACK FOOTER //
// ./source/client/components/summary_fulfillment/table.jsx